<script setup lang="ts">
import { nextTick, ref, toRefs, watchEffect } from 'vue'
import { kebabCase, omit } from 'lodash'
import { ThemeProps } from '@/components/theme/types'
import { BLUE_THEME } from '@/components/theme/themes'

defineOptions({
  name: 'lp-theme',
})

const props = withDefaults(defineProps<ThemeProps>(), BLUE_THEME)

const themeWrapper = ref<HTMLDivElement | null>(null)
watchEffect(() => {
  toRefs(props)
  if (props.isDisabled) {
    return
  }
  for (const prop in omit(props, ['isDisabled'])) {
    const fieldName = `--${kebabCase(prop)}`
    nextTick().then(() => {
      themeWrapper.value?.style.setProperty(
        fieldName,
        String(props[prop as keyof ThemeProps]).startsWith('--')
          ? `var(${props[prop as keyof ThemeProps]})`
          : String(props[prop as keyof ThemeProps]),
      )
    })
  }
})
</script>
<template>
  <div ref="themeWrapper" class="lp">
    <slot />
  </div>
</template>
